import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { getLanguage } from 'react-switch-lang';

export default function Redirect({ path, asIs }) {
  const router = useRouter();
  useEffect(() => {
    const lang = getLanguage();
    router.replace(asIs ? path : `/${lang}${path}`);
  }, [path, router, asIs]);
  return null;
}
